<script>
    import { fly, slide } from 'svelte/transition'
    import SearchBar from "../SearchBars/SearchBar.svelte"
    import Select from "svelte-select";
    import DateSearcher from "../SearchBars/DateSearcher.svelte";
    import RadioButtons from "../SearchBars/RadioButtons.svelte";
    import AreaSearcher from "../SearchBars/AreaSearcher.svelte";
    import CitySearcher from "../SearchBars/CitySearcher.svelte";
    import PrintCard from "../Cards/Print/PrintCard.svelte";
    import { onDestroy } from "svelte";
    import { getSubscribers } from "../../services/subscribersService";
    import { writable } from "svelte/store";
    import InfiniteScroll from "../Forms/InfiniteScroll.svelte";

    export let isOpen = true;
    export let disabledSubscribers = [];
    export let onConfirm;
    export let referenceYear;

    const statusFilterOptions = [
        { value: "isOnlinePayment", label: "Pagamento" },
        { value: "isUGS", label: "Partecipazione UGS" },
    ];
    const temporalFilterOptions = [
        { value: "membershipCreatedAt", label: "Inserimento" },
        { value: "paidAt", label: "Pagamento" }
    ];
    const areaFilterOptions = [
        { value: "residenceCountry", label: "Area" },
        { value: "residenceRegion", label: "Regione" },
        { value: "residenceProvince", label: "Provincia" },
        { value: "residenceCity", label: "Comune" },
    ];
    const paymentMethodOptions = [
        { label: "Bonifico Bancario", value: "false", id: "isOnlinePaymentFalse" },
        { label: "Pagamento Online", value: "true", id: "isOnlinePaymentTrue" },
    ];
    const isUGSOptions = [
        { label: "Partecipante", value: "true", id: "isUGSYes" },
        { label: "Non partecipante", value: "false", id: "isUGSNo" },
    ];
    const foreignOptions = [
        { label: "Italia", value: "false", id: "italianSubscriber" },
        { label: "Estero", value: "true", id: "foreignSubscriber" },
    ];
    let temporalFilter = "membershipCreatedAt";
    let spaceFilter = "residenceCountry";
    let statusFilter;
    let isExpanded = false;
    let modalFilters = writable({
        sort: undefined,
        referenceYear,
        active: true,
        page: 1,
        size: 200,
        wasPrinted: false
    });
    let hasMoreSubs = true;
    let selectedSubscribers = [];
    let subscribers = [];
    let isSelectedAll = false;

    const unsubscribeModalFilters = modalFilters.subscribe(() => {
        getSubscribers($modalFilters).then(value => {
            subscribers = [ ...subscribers, ...value.data.data];
            console.log(value.data.totalCount)
            hasMoreSubs = $modalFilters.page !== value.data.totalCount;

            refreshIsSelectedAll();
        })
    });

    function refreshIsSelectedAll() {
        if (!subscribers.length) {
            isSelectedAll = false;
            return;
        }

        isSelectedAll = subscribers.length === subscribers.filter((s) => selectedSubscribers.find(selectedS => selectedS.id === s.id)).length + getCurrentDisabledSubscribersCount().length;
    }

    function deleteSelectedSb(index) {
        selectedSubscribers = [...selectedSubscribers.toSpliced(index, 1)];
    }

    function toggleExpand() {
        isExpanded = !isExpanded;
    }

    function updateFilters(key, newValue) {
        subscribers = [];
        $modalFilters = { ...($modalFilters ?? {}), page: 1, [key]: newValue };
    }

    function handleSelectAll(value) {
        subscribers.forEach(sb => handleSubscriberSelect(value, sb));
    }

    function handleSubscriberSelect(isSelected, sb) {
        if (isSbDisabled(sb.id)) {
            return;
        }

        if (isSelected) {
            if (isSbSelected(sb.id)) {
                return;
            }

            selectedSubscribers = [ ...selectedSubscribers, sb ];
            refreshIsSelectedAll();

            return;
        }

        const toBeRemovedIndex = selectedSubscribers.findIndex((s) => s.id === sb.id);
        if (toBeRemovedIndex === -1) {
            return;
        }

        deleteSelectedSb(toBeRemovedIndex);
        isSelectedAll = false;
    }

    function getCurrentDisabledSubscribersCount() {
        return subscribers.filter((sb) => isSbDisabled(sb.id));
    }

    function sendSelectedSubscribers() {
        return onConfirm(selectedSubscribers);
    }

    function loadMoreSubscribers() {
        $modalFilters.page++;
    }

    onDestroy(() => {
        unsubscribeModalFilters();
    });

    $: isSbSelected = (id) => !!selectedSubscribers.find(sb => sb.id === id);
    $: isSbDisabled = (id) => !!disabledSubscribers.find(sbId => sbId === id);
</script>


{#if isOpen}
    <div
        class="large-modal w-10/12 md:w-9/12"
        transition:fly={{ y: -100 }}
        on:introstart
        on:outroend
    >
        <div class="font-bold text-2xl">
            Aggiungi tessere
        </div>

        <div class="text-gray-500 flex flex-row justify-between">
            <div>Filtra per</div>

            <div class="text-lightBlue-500 cursor-pointer" on:click={() => toggleExpand()}>
                {isExpanded ? "Riduci" : "Espandi"}
                <i class="fa pl-4  {isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}" />
            </div>
        </div>

        <div class="flex-grow flex flex-col gap-4">
            <div class="flex flex-col gap-1">
                <div class="flex flex-col items-center gap-1 w-full lg:flex-row">
                    <SearchBar
                        placeholder="Filtra per nome dell'iscritto"
                        hasLabel={false}
                        value={$modalFilters.firstName}
                        on:search={(e) => updateFilters("firstName", e.detail) }
                    />

                    <SearchBar
                        placeholder="Filtra per cognome dell'iscritto"
                        hasLabel={false}
                        value={$modalFilters.lastName}
                        on:search={(e) => updateFilters("lastName", e.detail) }
                    />
                </div>

                <SearchBar
                    placeholder="Filtra per email dell'iscritto"
                    hasLabel={false}
                    value={$modalFilters.email}
                    on:search={(e) => updateFilters("email", e.detail) }
                />

                {#if isExpanded}
                    <div class="flex flex-col items-center gap-1 w-full relative" in:slide>
                        <div class="flex flex-col items-center gap-1 w-full lg:flex-row">
                            <div class="w-full lg:w-6/12">
                                <Select
                                    items={temporalFilterOptions}
                                    floatingConfig={{ placement: 'top-start' }}
                                    id="timeFilter"
                                    type= "text"
                                    clearable={false}
                                    containerStyles={`border: 1px solid #D8D4D4; max-height: 2rem !important; min-height: 2.75rem; border-radius: 0px`}
                                    placeholder="Seleziona filtro temporale"
                                    bind:value={temporalFilter}
                                    on:input={(e) => updateFilters("timeFilter", e.detail.value)}
                                />
                            </div>

                            <div class="w-full lg:w-6/12">
                                {#if temporalFilter?.value === "membershipCreatedAt"}
                                    <div class="flex flex-col md:flex-row gap-1">
                                        <DateSearcher
                                            containerClass="no-shadow"
                                            placeholder="Dal"
                                            bind:value={$modalFilters.membershipCreatedFrom}
                                        />

                                        <DateSearcher
                                            containerClass="no-shadow"
                                            placeholder="Al"
                                            bind:value={$modalFilters.membershipCreatedTo}
                                        />
                                    </div>
                                {:else}
                                    <div class="flex gap-1 h-11">
                                        <div class="w-full flex items-center">
                                            <DateSearcher
                                                containerClass="no-shadow"
                                                placeholder="Dal"
                                                bind:value={$modalFilters.paymentDateFrom}
                                            />
                                        </div>
                                        <div class="w-full flex items-center">
                                            <DateSearcher
                                                containerClass="no-shadow"
                                                placeholder="Al"
                                                bind:value={$modalFilters.paymentDateTo}
                                            />
                                        </div>
                                    </div>
                                {/if}
                            </div>
                        </div>

                        <div class="flex flex-col items-center gap-1 w-full lg:flex-row">
                            <div class="w-full lg:w-6/12">
                                <Select
                                    items={areaFilterOptions}
                                    floatingConfig={{placement: 'top-start'}}
                                    type= "text"
                                    containerStyles={`border: 1px solid #D8D4D4; max-height: 2rem !important; min-height: 2.75rem; border-radius: 0px`}
                                    clearable={false}
                                    placeholder="Seleziona filtro spaziale"
                                    bind:value={spaceFilter}
                                />
                            </div>

                            <div class="w-full lg:w-6/12">
                                { #if !spaceFilter}
                                    <div class="flex items-center h-11 input-box-disabled pl-4">
                                        Seleziona un filtro
                                    </div>
                                {:else if spaceFilter.value === "residenceCountry"}
                                    <RadioButtons
                                        externalContainerClass="gap-1"
                                        containerClass="no-shadow"
                                        options={foreignOptions}
                                        isNullable={true}
                                        bind:inputValue={$modalFilters.residenceForeign}
                                    />
                                {:else if spaceFilter.value === "residenceRegion"}
                                    <div class="flex gap-1 h-11">
                                        <AreaSearcher
                                            bind:valueName={$modalFilters.residenceRegion}
                                            subject="region"
                                            placeholder="Seleziona una regione"
                                            clearable="true"
                                        />
                                    </div>
                                {:else if spaceFilter.value === "residenceCity"}
                                    <CitySearcher
                                        value={$modalFilters.residenceCity}
                                        handleChange={(e) => updateFilters("residenceCity", e.detail.value.name) }
                                        isSearchBar={true}
                                    />
                                {:else}
                                    <AreaSearcher
                                        bind:valueName={$modalFilters.residenceProvince}
                                        subject="province"
                                        placeholder="Seleziona una provincia"
                                        clearable="true"
                                    />
                                {/if}
                            </div>
                        </div>

                        <div class="flex flex-col items-center gap-1 w-full lg:flex-row">
                            <div class="w-full lg:w-6/12">
                                <Select
                                    items={statusFilterOptions}
                                    floatingConfig={{placement: 'top-start'}}
                                    id="statusFilter"
                                    clearable="{false}"
                                    type= "text"
                                    containerStyles={`border: 1px solid #D8D4D4; max-height: 2rem !important; min-height: 2.75rem; border-radius: 0px`}
                                    placeholder="Seleziona filtro per le iscrizioni"
                                    bind:value={statusFilter}
                                />
                            </div>

                            <div class="w-full lg:w-6/12">
                                {#if !statusFilter}
                                    <div class="flex items-center h-11 input-box-disabled pl-4">
                                        Seleziona un filtro
                                    </div>
                                {:else if statusFilter.value === "isOnlinePayment"}
                                    <RadioButtons
                                        externalContainerClass="gap-1"
                                        containerClass="no-shadow"
                                        options={paymentMethodOptions}
                                        isNullable={true}
                                        inputValue={$modalFilters.isOnlinePayment}
                                        on:input={(e) => updateFilters("isOnlinePayment", e.detail.value)}
                                    />
                                {:else}
                                    <RadioButtons
                                        externalContainerClass="gap-1"
                                        containerClass="no-shadow"
                                        options={isUGSOptions}
                                        isNullable={true}
                                        inputValue={$modalFilters.isUGS}
                                        on:input={(e) => updateFilters("isUGS", e.detail.value)}
                                    />
                                {/if}
                            </div>
                        </div>
                    </div>
                {/if}
            </div>

            <div class="table-scroll">
                <table class="w-full bg-transparent border-collapse py-4 overscroll-auto">
                    <thead class="border-b sticky top-0 shadow w-full z-3 bg-white h-4 overflow-x-auto">
                    <tr>
                        <th>
                            <div class="flex items-center justify-center">
                                <input
                                    class="cursor-pointer w-6 h-6 disabled:opacity-30 disabled:cursor-default"
                                    type="checkbox"
                                    bind:checked={isSelectedAll}
                                    on:input={(v) => {handleSelectAll(v.target.checked)}}
                                >
                            </div>
                        </th>
                        <th>Nome</th>
                        <th>Cognome</th>
                        <th>Email</th>
                        <th>Gruppo</th>
                        <th>Numero di telefono</th>
                        <th>Residenza</th>
                        <th>Data iscrizione</th>
                        <th>Data pagamento</th>
                        <th>Quota</th>
                    </tr>
                </thead>

                    <tbody class="font-normal relative tabella">
                        {#if (!!subscribers.length)}
                            {#each subscribers as sb}
                                <PrintCard
                                    subscriber="{sb}"
                                    checked={isSbSelected(sb.id)}
                                    disabled={isSbDisabled(sb.id)}
                                    bind:referenceYear={referenceYear}
                                    bind:membershipPrintIds="{selectedSubscribers}"
                                    on:selected={(event) => handleSubscriberSelect(event.detail.value, sb)}
                                />
                            {/each}
                        {:else}
                            <td class="font-semibold text-center" style="height: 15rem" colspan={10}>
                                Non ci sono tessere
                            </td>
                        {/if}
                    </tbody>
                </table>

                <InfiniteScroll
                    bind:hasMore={hasMoreSubs}
                    threshold={50}
                    horizontal={false}
                    on:loadMore={() => {loadMoreSubscribers()}}
                />
            </div>
        </div>


        <div>
            <div class="font-bold text-lg">Tessere selezionate:</div>
            <div class="w-full flex items-center gap-2 py-2 overflow-x-auto">
                {#if !selectedSubscribers.length}
                    <div class="w-full flex items-center justify-center h-12">Nessuna tessera selezionata</div>
                {:else}
                    {#each selectedSubscribers as selectedMb, index}
                        <div class="py-1 px-2 bg-gray-200 rounded-full flex items-center gap-4">
                            <div class="w-max">
                                {selectedMb.memberships[0].code} - {selectedMb.firstName} {selectedMb.lastName}
                            </div>

                            <i class="fa fa-times text-red-400 cursor-pointer" on:click|preventDefault={() => deleteSelectedSb(index)}></i>
                        </div>
                    {/each}
                {/if}
            </div>
        </div>

        {#if !!selectedSubscribers.length}
            <button
                class="flex justify-center items-center gap-2 border-0 bg-lightBlue-400 p-2 px-4 w-max
                 font-semibold text-white transition hover:shadow-lg outline-none focus:outline-none"
                on:click|preventDefault={sendSelectedSubscribers}
            >
                <i class="fa fa-plus"></i>

                Aggiungi {selectedSubscribers.length === 1 ? "una tessera" : selectedSubscribers.length + " tessere"}
            </button>
        {/if}
    </div>
{/if}

<style>
    .table-scroll {
        max-height: 30rem;
        overflow-y: auto;
    }

    .large-modal {
        border-radius: 5px;
        padding: 15px;
        position: fixed;
        background-color: white;
        z-index: 85;
        left: 50%;
        top: 3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 1rem;
        translate: -50%;
        overflow-y: auto;
        max-height: 85%;
    }
</style>
